module.exports = __webpack_public_path__ + "img/aaa.dadb5c2e.jpg";